

import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updateAracData, updatePaketlemeItem } from "../../../../../features/addLoad/addLoadSlice"
import { useState } from "react"
import { useEffect } from "react"
import { showModal } from "../../../../../features/modal/modalSlice"

const Container = styled.div`
    width: 500px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const AracAdetInput = ({data, name, isRequired, yukKayit}) => {
    const dispatch = useDispatch()
    const [text, setText] = useState(data?.aracSayisi)

    useEffect(()=> {
        setText(data.aracSayisi)
    },[data.aracSayisi])


//     const handleChange = (e) => {
//     if (/^[0-9.,]+$/.test(e.target.value)) {
//         dispatch(updateAracData({aracSayisi: e.target.value}))
//         setText(e.target.value)

//         if(parseInt(e.target.value) >= 5){
//             dispatch(showModal("loadAracAdet"))
//         }
//     }
// }

//! ffk
const handleChange = (e) => {
    const inputValue = e.target.value;

    //! Eğer input sadece "1" ise veya input boşsa, varsayılan değeri sil
    if ( inputValue === '') {
        dispatch(updateAracData({ aracSayisi: '' })); //! Varsayılan değeri sil
        setText(''); //! State'teki değeri sıfırla
    } else if (/^[0-9.,]+$/.test(inputValue)) {
        dispatch(updateAracData({ aracSayisi: inputValue }));
        
        setText(inputValue);
        
        // if (parseInt(inputValue) >= 5 && data.aracSayisiKontrol === false && !yukKayit) {
        //     dispatch(showModal("loadAracAdet"));
        //     dispatch(updateAracData({ aracSayisiKontrol: true }));
        // }

    }
}
 
  return (
    <Container value={text} radius={"5px"}>
        <input type="text" id={"text"} onChange={(e) => handleChange(e)} value={text} name={name}/> 
        <label htmlFor={"text"}>Araç Adeti</label>
    </Container>
  )
}

export default AracAdetInput